import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { scrollTop } from "../../utils/window";
import { useContext } from "react";
import FeedbackContext from "../../context/cmscontext";
import {
  HiOutlineGlobeAlt,
  HiOutlineShieldCheck,
  HiOutlineOfficeBuilding,
  HiOutlineArrowRight,
} from "react-icons/hi";

const publicUrl = process.env.PUBLIC_URL || "";

function AboutUs() {
  const { feedback } = useContext(FeedbackContext);
  const about_us = feedback.about_us;

  useEffect(() => {
    scrollTop();
  }, []);

  const stories = [
    {
      id: "services",
      step: "01",
      icon: HiOutlineGlobeAlt,
      title: about_us.our_text,
      description: about_us.our_desc,
      image: `${publicUrl}/images/about-services.jpg`,
      featured: true,
    },
    {
      id: "standard",
      step: "02",
      icon: HiOutlineShieldCheck,
      title: about_us.a_new_text,
      description: about_us.a_new_desc,
      image: `${publicUrl}/images/about-standard.jpg`,
    },
    {
      id: "platform",
      step: "03",
      icon: HiOutlineOfficeBuilding,
      title: about_us.pakistan_text,
      description: about_us.pakistan_desc,
      image: `${publicUrl}/images/about-platform.jpg`,
    },
  ];

  return (
    <div className="pi-about">
      <header className="pi-inner-hero">
        <div className="pi-inner-hero__media" aria-hidden="true">
          <img
            className="pi-inner-hero__media-img"
            src={`${publicUrl}/images/about-hero.jpg`}
            alt=""
          />
          <span className="pi-inner-hero__media-shade" />
        </div>
        <div className="pi-inner-hero__fx" aria-hidden="true">
          <span className="pi-inner-hero__glow pi-inner-hero__glow--a" />
          <span className="pi-inner-hero__glow pi-inner-hero__glow--b" />
          <span className="pi-inner-hero__grid" />
        </div>
        <div className="pi-inner-hero__content">
          <div className="pi-inner-hero__copy">
            <p className="pi-label pi-inner-hero__label">Our story</p>
            <h1 className="pi-inner-hero__title">{about_us.who_text}</h1>
            <p className="pi-inner-hero__lead">{about_us.who_desc}</p>
          </div>
        </div>
        <span className="pi-inner-hero__fade" aria-hidden="true" />
      </header>

      <div className="pi-about__body">
        <div className="pi-about__inner">
          <section className="pi-about__stories" aria-label="What we do">
            <div className="pi-section-head">
              <p className="pi-label">What we do</p>
              <h2>{about_us.who_desc}</h2>
            </div>

            <div className="pi-about__story-grid">
              {stories.map((story) => {
                const Icon = story.icon;
                return (
                  <article
                    key={story.id}
                    className={[
                      "pi-about__story",
                      story.featured ? "pi-about__story--featured" : "",
                    ]
                      .filter(Boolean)
                      .join(" ")}
                  >
                    <div className="pi-about__story-media">
                      <img src={story.image} alt="" />
                      <span className="pi-about__story-media-shade" aria-hidden />
                      <span className="pi-about__story-step" aria-hidden>
                        {story.step}
                      </span>
                    </div>
                    <div className="pi-about__story-body">
                      <span className="pi-about__story-icon" aria-hidden>
                        <Icon size={20} />
                      </span>
                      <h3>{story.title}</h3>
                      <p>{story.description}</p>
                    </div>
                  </article>
                );
              })}
            </div>
          </section>

          <section className="pi-about__cta" aria-label="Get in touch">
            <div className="pi-about__cta-card">
              <div className="pi-about__cta-visual" aria-hidden>
                <img
                  className="pi-about__cta-visual-img"
                  src={`${publicUrl}/images/about-cta-partnership.png`}
                  alt=""
                />
              </div>
              <div className="pi-about__cta-content">
                <div className="pi-about__cta-content-inner">
                  <span className="pi-about__cta-eyebrow">Next step</span>
                  <h2>Ready to work with AutoTrade Port?</h2>
                  <p>
                    Whether you are selling a single vehicle or managing a fleet, our team is
                    here to help you move forward with confidence.
                  </p>
                  <Link to="/contactus" className="pi-about__cta-btn" name="CTAButton">
                    Contact us
                    <HiOutlineArrowRight size={18} aria-hidden />
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
